import { useRef, useEffect } from "react";
// hook to check if component has unmounted
// always returns false until component unmounts (then it will return true)
function useUnmounted() {
    const isUnmounted = useRef(false);
    useEffect(
        () => () => {
            isUnmounted.current = true;
        },
        []
    );
    return () => isUnmounted.current;
}

export default useUnmounted;
